import { Tooltip as BsTooltip } from 'bootstrap';
import { BaseFCProps, FC } from '../components';

export interface TooltipProps extends BaseFCProps {}

export const Tooltip: FC = ({ selector = '[data-bs-toggle="tooltip"]' }: TooltipProps = {}) => {
  Array.from(document.querySelectorAll(selector)).forEach((tooltipNode) => {
    new BsTooltip(tooltipNode)
  });
}